import $ from 'jquery'

$(function() {
  const url = new URL(window.location.href)
  let priceParam = url.searchParams.get('price')
  const soldoutParam = url.searchParams.get('sold_out')
  if (priceParam) {
    priceParam = priceParam.replace(/\//g, '')
  }

  function orderParamsCheck() {
    const activeClass = 'bg-yellow-500 text-white border-none'

    if( priceParam === '1' ) {
      $('#order-cheap').addClass(activeClass)
    }else if( priceParam === '2' ) {
      $('#order-dear').addClass(activeClass)
    }

    if( soldoutParam ) {
      $('#order-soldout').addClass(activeClass)
    }
  }
  orderParamsCheck()

  $('#order-cheap').on('click', function() {
    url.searchParams.delete('page')
    url.searchParams.delete('price')

    if( priceParam === '1') {
      url.searchParams.delete('price')
      url.searchParams.delete('page')
    } else {
      url.searchParams.append('price','1')
    }

    location.href = url
  })

  $('#order-dear').on('click', function() {
    url.searchParams.delete('page')
    url.searchParams.delete('price')

    if( priceParam === '2') {
      url.searchParams.delete('price')
      url.searchParams.delete('page')
    } else {
      url.searchParams.append('price','2')
    }

    location.href = url
  })

  $('#order-soldout').on('click', function() {
    url.searchParams.delete('sold_out')
    url.searchParams.delete('price')
    url.searchParams.delete('page')

    if( soldoutParam ) {
      url.searchParams.delete('sold_out')
    } else {
      url.searchParams.append('sold_out','1')
    }

    if( priceParam ) {
      url.searchParams.append('price', priceParam)
    }

    location.href = url
  })
})

